export const isValidFiscalCodeOrVat = (value: string) => {
  const patternCF = /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/
  const patternVAT = /^[0-9]{11}$/
  const isValidCf = patternCF.test(value)
  const isValidVat = patternVAT.test(value)
  return isValidCf || isValidVat
}
